
// reworked from https://codesandbox.io/s/wheel-of-prize-forked-zikutr
import {
	calculateCurrentAngle,
} from './angle';
import {
	spinTime,
} from './constants';

const pauseAfterStopBeforeShowWinner = 400;
const winnerShowTime = 5000;

export const runAnimation = (paint, state, settings, totalAngle) => {
	let start, previousTimestamp, end;

	const step = (timestamp) => {
		if (state.dismissed) {
			settings.onFinish();
			return;
		}
		if (start === undefined) {
			start = timestamp;
			end = timestamp + spinTime;
		}
		paint();

		if (previousTimestamp !== timestamp) {
			const elapsed = timestamp - start;
			const nextAngle = calculateCurrentAngle(elapsed, totalAngle);

			state.angle = nextAngle;
			if (timestamp < end) {
				previousTimestamp = timestamp;
				window.requestAnimationFrame(step);
			} else {
				setTimeout(settings.onShowWinner, pauseAfterStopBeforeShowWinner);
				
				setTimeout(settings.onFinish, winnerShowTime);
			}
		} else {
			window.requestAnimationFrame(step);
		}
	};

	window.requestAnimationFrame(step);
};
